import { Observable } from "rxjs";
import { WebServicesService } from "../webservices.service";
import { ApiService } from "./_api.service";
import { ArticleType } from "src/app/_models/articletype";
import { environment } from 'src/environments/environment';

export class ArticleTypeApiService{
    constructor(private _ws: WebServicesService){}

    get(): Observable<ArticleType[]> {
        const url = `${environment.wsBaseUrl}/api/Article/Types`;
        return this._ws.getWithCache(url, ApiService.CACHEKEY_ARTICLE_TYPES);
    }
}
